import { render, staticRenderFns } from "./page-perso.vue?vue&type=template&id=4ba0dd76"
import script from "./page-perso.vue?vue&type=script&lang=ts"
export * from "./page-perso.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ba0dd76')) {
      api.createRecord('4ba0dd76', component.options)
    } else {
      api.reload('4ba0dd76', component.options)
    }
    module.hot.accept("./page-perso.vue?vue&type=template&id=4ba0dd76", function () {
      api.rerender('4ba0dd76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/page-perso.vue"
export default component.exports